import { CharacterResult } from "common/character/dto/CharacterResult";
import { InputWayTextCharElement } from "common/topic/input_way_text";
import { AddRecognizePosBorders } from "./TextCharEditPayload.logic";

export function textCharNavActivateInitial(
  editElements: InputWayTextCharElement[]
): boolean[][] {
  const n = editElements.length;
  let res: boolean[][] = Array(n).fill([]);
  for (let i = 0; i < n; i++) {
    const editEl = editElements[i];
    const elLength: number = editEl.isCharacter
      ? (editEl.value as CharacterResult).letter.length
      : (editEl.value as string).length;
    res[i] = Array(elLength).fill(false);
  }
  res[n] = [false];

  return res;
}

export function textCharNavActivePosBorders(
  textCharNavActivate: boolean[][]
): AddRecognizePosBorders {
  const res = { i1: -1, j1: -1, i2: -1, j2: -1 };
  for (let k = 0; k < textCharNavActivate.length; k++) {
    const elementNavActivate = textCharNavActivate[k];
    for (let l = 0; l < elementNavActivate.length; l++) {
      if (elementNavActivate[l]) {
        if (res.i1 === -1) {
          res.i1 = k;
          res.j1 = l;
        } else {
          res.i2 = k;
          res.j2 = l;
          break;
        }
      }
    }
    if (res.i2 >= 0) {
      break;
    }
  }

  return res;
}

function textCharNavActiveCount(textCharNavActivate: boolean[][]): number {
  const res: number = textCharNavActivate.reduce(
    (previousValue: number, currentValue: boolean[]) => {
      const value = previousValue + elementNavActiveCount(currentValue);
      return value;
    },
    0
  );

  return res;
}

function elementNavActiveCount(elementNavActivate: boolean[]): number {
  const res: number = elementNavActivate.reduce(
    (previousValue: number, currentValue: boolean) => {
      let value = previousValue;
      if (currentValue) {
        value++;
      }
      return value;
    },
    0
  );

  return res;
}

export function toggleElementNavActivatePos(
  textCharNavActivate: boolean[][],
  textCharInd: number,
  elInd: number
): boolean[][] {
  const proposeActive: boolean = !textCharNavActivate[textCharInd][elInd];
  let res = textCharNavActivate;
  if (!proposeActive) {
    res = [...textCharNavActivate];
    res[textCharInd][elInd] = proposeActive;
  } else {
    const activeCount = textCharNavActiveCount(textCharNavActivate);
    if (activeCount <= 1) {
      res = [...textCharNavActivate];
      res[textCharInd][elInd] = proposeActive;
    }
  }

  return res;
}
